<template>
    <form @submit.prevent="submit()">
        <div class="form-group">
            <label for="type" class="col-sm-5 control-label">Seleccione tipo de categoría a ordenar</label>
            <div class="col-sm-7">
                <el-select filterable clearable v-model="selectedType">
                    <el-option v-for="i in types" :key="i" :label="i" :value="i"></el-option>
                </el-select>
                <div class="help-block" v-for="e in errors['type']">{{e}}</div>
            </div>
        </div><p>&nbsp;</p>
        <ul v-if="selectedType=='aclara-tus-dudas'" class="row cards-grid">
            <draggable v-model="data.dudas"  @start="drag=true" @end="drag=false">
                <li v-for="element in data.dudas" :key="element.id" class="col-12">
                    <a @click.prevent="" :href="'coronavirus/'+element.url" :title="element.name">
                        <article class="card">
                            <div>
                                <span :class="element.icon"></span>
                            </div>
                            <h2>
                                <strong>{{ element.name }}</strong>
                            </h2>

                        </article>
                    </a>
                </li>        
            </draggable>
        </ul>


        <ul v-if="selectedType=='beneficios-persona'" class="row cards-grid">
            <draggable v-model="data.beneficios"  @start="drag=true" @end="drag=false">
                <li v-for="element in data.beneficios" :key="element.id" class="col-12">
                    <a @click.prevent="" :href="'coronavirus/'+element.url" :title="element.name">
                        <article class="card">
                            <div>
                                <span :class="element.icon"></span>
                            </div>
                            <h2>
                                <strong>{{ element.name }}</strong>
                            </h2>

                        </article>
                    </a>
                </li>        
            </draggable>
        </ul>

        <div v-if="selectedType=='lo-que-debes-saber'" class="bullet-page">
            <draggable v-model="data.debes_saber"  @start="drag=true" @end="drag=false">

                    <a v-for="element in data.debes_saber" :key="element.id" @click.prevent="" :title="element.name" :href="'coronavirus/'+element.url" class="stage-block ">
                        <div class="block-header">
                            <h4>{{element.name}}</h4>
                        </div>
                    </a>
            </draggable>
        </div>

        <div class="row">
            <div class="col-xs-12 text-center">
                <a class="btn btn-default" :href="'backend/faqs/'+this.faq.id">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>    
</template>
<style lang="scss" scoped>
    .wrapper-drag {
        display: flex;
    }
    
    /*** */

    .card * {
        font-weight: normal;
    }
    .cards-grid {
        list-style: none;
        padding: 0px;
        margin: 0px;
    }
    .cards-grid a {
        text-decoration: none;
    }
    *, :after, :before {
        box-sizing: border-box;
    }
    @media (min-width: 992px){
        .col-md-6 {
            width: 50%;
        }
    }
    .cards-grid li {
        list-style: none;
        margin: 0px;
        padding: 0px 10px;
    }
    .cards-grid li article h2 {
        font-family: 'Roboto Slab';
        padding: 100px 0px 10px 0px;
        color: #000;
        font-size: 22px !important;
        padding-right: 120px;

        margin-top: 20px;
        margin-bottom: 10px;
    }
    .cards-grid li article h2 {
        color: #000;
        font-size: 22px!important;
        padding: 20px 120px 30px 0px !important;
    }
    .cards-grid li article h2 strong {
        font-weight: 600!important;
    }
    .cards-grid article.card {
        position: relative;
        max-height: 133px;
        top: 0px;
        transition: top, 0.3s, box-shadow, 0.3s;
    }
    .cards-grid li article {
        height: auto;
    }
    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        width: 550px;
        min-height: 133px;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: none;
        border-radius: 10px;
        padding: 12px 18px 18px;
        margin-bottom: 25px;
        font-weight: 400;
        overflow: hidden;
        -webkit-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        -moz-box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
        box-shadow: 0px 0px 11px -1px rgba(0,0,0,0.11);
    }

    .cards-grid li article span {
        font-size: 110px;
        position: absolute;
        right: 20px;
        top: 20px;
    }


    /***** */
    .bullet-page .stage-block {
        min-height: inherit;
        float: left;
        margin-bottom: 10px;
        box-shadow: none;
        border: 1px solid #ffd7d6;
        border-radius: 2px;
        background-color: #fff;
        a {
            color: black;
        }
    }

    .stage-block {
        box-shadow: 0px 0px 4px #bbbbbb;
        border-radius: 8px;
        overflow: hidden;
        display: block;
        transition: .4s;
        min-width: 166px;
        width: 500px;
        position: relative;
    }

    .stage-block .block-header {
        position: relative;
        float: left;
    }

    .stage-block h4 {
        padding: 15px 16px !important;
        color: #000 !important;
        font-family: 'Roboto Slab';
        margin: 0;
        color: #0F69B4;
        line-height: 120%;
        font-size: 18px;
        padding: 15px 16px 0 16px;
        float: left;
        width: calc(100% - 70px);
    }
 .icon-icon-escuela:before {
    content: "\e904";
    color: #0f69b4;
  }
  .icon-icon-estudio:before {
    content: "\e905";
    color: #0f69b4;
  }
  .icon-icon-migracion:before {
    content: "\e906";
    color: #0f69b4;
  }
  .icon-icon-salud:before {
    content: "\e907";
    color: #0f69b4;
  }
  .icon-icon-trabajo:before {
    content: "\e908";
    color: #0f69b4;
  }
  .icon-icon-viaje:before {
    content: "\e909";
    color: #0f69b4;
  }
  .icon-icon-flecha:before {
    content: "\e903";
    color: #0f69b4;
  }
  .icon-icon-coronavirus-blanco:before {
    content: "\e902";
    color: #fff;
  }
  .icon-icon-escudo:before {
    content: "\e900";
    color: #0f69b4;
  }
  .icon-icon-coronavirus:before {
    content: "\e901";
    color: #0f69b4;
  }

  /*Agregar estas dos reglas a la lista de la familia 'covid' en etapas_corona.css, línea 953*/
.icon-icon-documento:before {
    content: "\e90a";
    color: #0f69b4;
  }
  .icon-icon-pyme:before {
    content: "\e90b";
    color: #0f69b4;
  }
  .icon-icon-huaso:before {
    content: "\e913";
    color: #0f69b4;
  }
  .icon-icon-canasta:before {
  content: "\E90C";
  color: #0f69b4;
  }
  .icon-icon-news:before {
  content: "\E90D";
  color: #0f69b4;
  }
  .icon-icon-beneficios:before {
  content: "\E90E";
  color: #0f69b4;
  }
  .icon-icon-sofa:before {
  content: "\E90F";
  color: #0f69b4;
  }
  .icon-icon-judicial:before {
  content: "\E911";
  color: #0f69b4;
  }
  .icon-icon-cuarentena:before {
  content: "\E910";
  color: #0f69b4;
  }
  .icon-icon-presencial:before {
  content: "\E912";
  color: #0f69b4;
}

.line-left[data-v-27d8e0b4] {
    background: #0080ec;
}
</style>
<script>
import draggable from 'vuedraggable';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';

//transform object to array for draggable manipulation
function valuesToArray(obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
}

export default {
    data: function(){
        var filterDudas = _(this.topics)
            .filter(function(d){
                return d.type === 'aclara-tus-dudas';
            })
            .values()
            .orderBy(function(d){
                return d.order;
            }, 'asc')
            .value();

        var filterDebesSaber = _(this.topics)
            .filter(function(d){
                return d.type === 'lo-que-debes-saber';
            })
            .values()
            .orderBy(function(d){
                return d.order;
            }, 'asc')
            .value();

        var filterBeneficios = _(this.topics)
            .filter(function(d){
                return d.type === 'beneficios-persona';
            })
            .values()
            .orderBy(function(d){
                return d.order;
            }, 'asc')
            .value();


        var arr = {
            dudas: valuesToArray(filterDudas),
            debes_saber: valuesToArray(filterDebesSaber),
            beneficios: valuesToArray(filterBeneficios)
        };


        return {
            data: _.cloneDeep(arr),
            selectedType: 'aclara-tus-dudas',
            errors: {}
        }
    },
    props: ['topics','faq'],
    components: {
        draggable,
    },
    computed: {
        types: function(){
            var list = [];
            const set = new Set(['aclara-tus-dudas','lo-que-debes-saber','beneficios-persona']);
            list = Array.from(set);
            return list;
        },
    },
    methods: {
        submit: function() {
            var self = this;

            axios({
                url: 'backend/faqs/'+self.faq.id+'/order',
                method: 'POST',
                data: self.data,
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        }        
    },
}
</script>